import React from 'react'

import NoSearchResult from 'components/NoSearchResult/NoSearchResult'
import DeviceItem from './DeviceItem'
import { modalTypesConstant } from '../DevicesManagement'

const PageBody = ({ handleEdit, devicesList, isFetching }) => {
  return (
    <div className="device_manager_body_container">
      <div className="device_manager_body_wrap">
        {devicesList.length ? (
          devicesList.map((device) => (
            <DeviceItem
              key={device.id}
              handleEditOpen={handleEdit(modalTypesConstant.edit)}
              {...device}
            />
          ))
        ) : (
          <NoSearchResult title={isFetching ? 'Loading...' : 'No result'} />
        )}
      </div>
    </div>
  )
}

export default PageBody
